<script setup lang="ts">
// Composables
import { useStartProjectModal } from "@/pages/Projects/composables/useStartProjectModal.composable";

// Components
import { Plus } from "@lucide/vue";

/**
 * "New Project", which opens the dialog that carries the whole create flow.
 *
 * It used to ask the shape-deciding questions here and then redirect to /create-project with the
 * answers seeded into the store. The dialog asks them and creates the project itself now, so this
 * button opens it and nothing else. The `modals.open` call lives in the composable because three
 * other places offer the same action.
 */
const { openStartProjectModal } = useStartProjectModal();
</script>

<template>
  <button
    id="create-project-button"
    type="button"
    aria-label="Create project"
    aria-haspopup="dialog"
    title="Create project"
    data-cy="create-project"
    class="rounded-8 bg-slate-0 text-type-default focus-ring interactive-active duration-fast ease-standard ring-slate-250 inline-flex h-fit shrink-0 items-center justify-center gap-2 p-2 pr-2 ring-1 transition-all hover:bg-slate-100 hover:ring-slate-300"
    @click="openStartProjectModal">
    <Plus
      class="icon-sm shrink-0"
      :stroke-width="1.5"
      color="var(--color-app-blue-800)"
      fill="var(--color-app-blue-100)" />
    <span class="t-caption-bold whitespace-nowrap">New Project</span>
  </button>
</template>
